import { render, staticRenderFns } from "./productVariantsDataUpdateNew.vue?vue&type=template&id=01805c64&scoped=true"
import script from "./productVariantsDataUpdateNew.vue?vue&type=script&lang=js"
export * from "./productVariantsDataUpdateNew.vue?vue&type=script&lang=js"
import style0 from "./productVariantsDataUpdateNew.vue?vue&type=style&index=0&id=01805c64&prod&lang=scss&scoped=true"
import style1 from "./productVariantsDataUpdateNew.vue?vue&type=style&index=1&id=01805c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01805c64",
  null
  
)

export default component.exports